module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/payment_submitted-f2f0f80b9e613c701e92b395325249b4.png";